module.exports = __webpack_public_path__ + "images/lead-header.75674887728cd4313f9bec866e435378.jpg";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/images/lead-header.jpg
// module id = 1008
// module chunks = 0